/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Tlm_1Inputs */

const en_svc_rag_knowledge_assistants_tlm_1 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sources`)
};

const ar_svc_rag_knowledge_assistants_tlm_1 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المصادر`)
};

const bn_svc_rag_knowledge_assistants_tlm_1 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`উৎস`)
};

const de_svc_rag_knowledge_assistants_tlm_1 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellen`)
};

const es_svc_rag_knowledge_assistants_tlm_1 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuentes`)
};

const fr_svc_rag_knowledge_assistants_tlm_1 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources`)
};

const pt_svc_rag_knowledge_assistants_tlm_1 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fontes`)
};

const zh_svc_rag_knowledge_assistants_tlm_1 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来源`)
};

const tr_svc_rag_knowledge_assistants_tlm_1 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaynaklar`)
};

const ru_svc_rag_knowledge_assistants_tlm_1 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Источники`)
};

const pl_svc_rag_knowledge_assistants_tlm_1 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Źródła`)
};

/**
* | output |
* | --- |
* | "sources" |
*
* @param {Svc_Rag_Knowledge_Assistants_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_tlm_1 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_tlm_1(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_tlm_1(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_tlm_1(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_tlm_1(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_tlm_1(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_tlm_1(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_tlm_1(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_tlm_1(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_tlm_1(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_tlm_1(inputs)
	return en_svc_rag_knowledge_assistants_tlm_1(inputs)
});
export { svc_rag_knowledge_assistants_tlm_1 as "svc_rag-knowledge-assistants_tlm_1" }